
import { useState } from "react";

import { FilledButton, OutlinedButton } from "../../common/Button";

import Lightbox from "../../common/Lightbox";

import useDisplayNotifications from "../../../hooks/useDisplayNotifications";
import useMyProjects from "../../../hooks/useMyProjects";
import { DisplayNotificationType } from "../../../models/DisplayNotification";
import { IProject } from "../../../data_models/project";
import { MdOutlineDeleteOutline } from "react-icons/md";
import useRouting from "../../../hooks/useRouting";


interface ConfirmDeleteProjectDraftLightboxProps {
    project: IProject;
    onClose: () => void;
}

export const ConfirmDeleteProjectDraftLightbox: React.FC<ConfirmDeleteProjectDraftLightboxProps> = ({ project, onClose }) => {

    const [loading, setLoading] = useState(false);
    const { deleteProjectDraft } = useMyProjects();
    const { addNotification } = useDisplayNotifications();

    const { goToDashboard } = useRouting();

    const onDeleteDraft = async () => {
        try {
            setLoading(true);
            await deleteProjectDraft(project._id!);
        } catch (error: any) {
            addNotification({
                message: error.message,
                type: DisplayNotificationType.ERROR
            });
        } finally {
            setLoading(false);
            goToDashboard();
            onClose();
        }
    }


    return (
        <Lightbox
            header="Delete Project"
            onClose={onClose}
            onDelete={onDeleteDraft}
            onCancel={onClose}
            content={
                <div className="flex flex-col space-y-6 w-full" >
                    <p>This will permanently delete this project. This action cannot be undone.</p>
                </div>}
        />
    );
}

